<div class="dialog-container xsmall-dialog">
  <!-- <h3 class="dialog-header">
    <button (click)="dialogRef.close()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </h3> -->
  <div class="dialog-content">
    آیا اطمینان دارید؟
  </div>
  <div class="dialog-action">
    <button mat-button (click)="dialogRef.close()">انصراف</button>
    <button mat-raised-button (click)="dialogRef.close(true)" color="primary">تایید</button>
  </div>
</div>
